import doNothing from "../../actions/thunks/successHandlers/doNothing";
import { makeCallWithOptions } from "../../actions/thunks/schemaThunks";

const dispatchCallWithOptions = (
  component,
  {
    verb,
    accessToken,
    endpoint,
    errorHandler = doNothing,
    successHandler,
    payload,
    options: {
      navigate = null,
      successMessage = null,
      successRedirectUrl = null,
      id = null,
      castToJson = true,
      property = null,
      fetchOptions = null,
      refetchOptions = null,
    },
  }
) => {
  component.props.dispatch(
    makeCallWithOptions({
      verb,
      accessToken,
      endpoint,
      errorHandler,
      successHandler,
      payload,
      options: {
        navigate,
        successMessage,
        successRedirectUrl,
        id,
        castToJson,
        property,
        fetchOptions,
        refetchOptions,
      },
    })
  );
};

export default dispatchCallWithOptions;
